import React from 'react';
import PropTypes from 'prop-types';
import { I18n, I18nContext } from '@deporvillage/utils-library-component';
import Customer from './utils/customer';

import styles from './Form.module.scss';

const Input = ({
    id, type, value, label, onChange,
}) => {

    const [tooglePassword, setTooglePassword] = React.useState(true);
    const isInputPassword = id === Customer.password.id || id === Customer.passwordConfirmation.id;
    const toogleType = tooglePassword ? 'password' : 'text';
    const inputType = isInputPassword ? toogleType : type

    const handleClick = () => setTooglePassword(!tooglePassword);
    const handleOnChange = (e) => onChange && onChange(e.target.value);

    return (
        <div className={styles['form-input']}>
            <input
                className={`${value ? styles['has-value'] : ''}`}
                id={id}
                type={inputType}
                defaultValue={value || ''}
                onChange={handleOnChange}
                onFocus={isInputPassword ? handleOnChange : undefined}
                placeholder={' '}
                autoComplete={'off'}
            />
            <label htmlFor={id}>
                <I18n>
                    {label}
                </I18n>*
            </label>
            {isInputPassword &&
                <i onClick={handleClick} className={`${tooglePassword ? `${styles['icon']} icon icon-closed-eye` : `${styles['icon']} icon icon-eye`}
                    ${styles['toogle-password']}
                `} />
            }
        </div>
    );
};

Input.propTypes = {
    id: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
};

const Checkbox = ({
    id, value, label, onChange,
}) => {
    const { translate } = React.useContext(I18nContext);

    return (
        <div className={styles['input-checkbox']}>
            <input
                id={id}
                type={'checkbox'}
                defaultChecked={value}
                onChange={(e) => onChange && onChange(e.target.checked)}
            />

            <label htmlFor={id} className={styles.label}
                dangerouslySetInnerHTML={{
                    __html: translate(label),
                }}
            />
        </div>
    );
};

Checkbox.propTypes = {
    id: PropTypes.string,
    value: PropTypes.bool,
    label: PropTypes.string,
    onChange: PropTypes.func,
};

const Select = ({ id, value, options, onChange }) => {

    const { translate } = React.useContext(I18nContext);

    const handleOnChange = (e) => {
        onChange && onChange(e.target.value)};

    return (
        <div className={`${styles['input-select']}`}>
            <select id={id} value={value || ''} onChange={handleOnChange}>
                {(options || []).map((option) => (
                    <option
                        key={option.value}
                        value={option.value}
                        disabled={option?.disabled}
                        dangerouslySetInnerHTML={{
                            __html: translate(option.key) + `${option?.disabled ? '*' : ''}`,
                        }} />
                ))}
            </select>
        </div>
    );
};

Select.propTypes = {
    id: PropTypes.string,
    value: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string,
            value: PropTypes.string,
            disabled: PropTypes.bool,
        }),
    ),
    onChange: PropTypes.func,
};

const Form = (props) => {
    const getForm = () => {
        switch (props.type) {
            case 'text':
            case 'email':
            case 'password':
                return <Input {...props} />;
            case 'select':
                return <Select {...props} />;
            case 'checkbox':
                return <Checkbox {...props} value={!!props.value} />;
            default:
                return null;
        };
    };

    return (
        <div className={`${styles['form-input-wrapper']} ${props.error && props.type !== 'checkbox' ? styles.error : styles['checkbox-error']}`}>
            {getForm()}
            {props.error && <span><I18n>{props.error}</I18n></span>}
        </div>
    );
};

export default Form;
